module.exports = {
	"dk": {
		"defaultTitle": "TV3 SPORT »",
		"titleTemplate": "%s » TV3 SPORT",
		"siteName": "TV3 SPORT"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/metadata.json
// module id = 1207
// module chunks = 0 1